export const getCustomer = state => state.customer;
export const getEmail = state => state.customer.email;
export const getFirstName = state => state.customer.firstName;
export const getLastName = state => state.customer.lastName;
export const getEventSecrets = state => state.customer.eventSecrets;
export const getGender = state => state.customer.gender;
export const getIsWelcomeBoxActive = state => state.customer.isWelcomeBoxActive;
export const getMyFilter = state => state.customer.myFilter;
export const getCurrency = state => state.customer.currency;
export const getIsLoggedIn = state => state.customer.isLoggedIn;
export const getHashedCustomerNumber = state => state.customer.hashedCustomerNumber;
export const getCountryOfResidence = state => state.customer.countryOfResidence;
export const getIsSubscribedToNewsletter = state => state.customer.nwlSubscription;
export const getHasEmailConfirmed = state => state.customer.mailConfirmed;
export const getHasOrders = state => state.customer.countedCustomerOrders > 0;
export const getEmailProvider = state => state.customer.emailProvider;
export const getNewsletterSubscriptionPending = state => state.customer.newsletterSubscriptionPending;
export const getNewsletterErrorCount = state => state.customer.newsletterErrorCount;
export const getNewsletterError = state => state.customer.newsletterError;
export const getIsTrackingOptedIn = state => state.customer.isTrackingOptedIn;
